import { actions } from "./actions";
import { getRoomById } from "./selectors";
import { Floor, addFloor, removeFloor, updateFloor, addRoom, moveRoom, updateRoom } from "../dataModels";

export function Reducer(state, action) {

    switch (action.type) {
        // UI actions
        case actions.SET_GRID_SIZE:
            return { ...state, ui: { ...state.ui, gridSize: action.payload.gridSize } };
        // Building actions
        case actions.ADD_FLOOR:
            const newFloor = Floor();
            return { ...state, building: addFloor(state.building, newFloor) };
        case actions.REMOVE_FLOOR:
            return { ...state, building: removeFloor(state.building, action.payload.floorId) };
        case actions.ADD_ROOM:
            console.log('ADD_ROOM', action.payload);
            const { room, floorId } = action.payload;
            const floorToUpdate = state.building.floors.find(f => f.id === floorId);
            if (floorToUpdate) {
                const updatedFloor = addRoom(floorToUpdate, room);
                const res =  { ...state, building: updateFloor(state.building, updatedFloor) };
                console.log('ADD_ROOM', res);
                return res;
            }
            return state;
        case actions.UPDATE_ROOM_POSITION:
            const roomToUpdatePosition = action.payload.room;
            if (roomToUpdatePosition) {
                const updatedRoom = moveRoom(roomToUpdatePosition, action.payload.position);
                const toRet = { ...state, building: updateRoom(state.building, roomToUpdatePosition.id, updatedRoom) };
                console.log('UPDATE_ROOM_POSITION', toRet);
                return toRet;
            }
            return state;
        case actions.UPDATE_ROOM:
            const roomToUpdate = action.payload.room;
            if (roomToUpdate) {
                const toRet = { ...state, building: updateRoom(state.building, roomToUpdate.id, roomToUpdate) };
                console.log('UPDATE_ROOM', toRet);
                return toRet;
            }
            return state;
        default:
            return state;
    }
}